import Module from '../module';
import scroll from '../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			siteMapListContentPageLinksItemWrapperCls: string;
		}
	},

	slug: string
}

class List extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Site Map List Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();

		for(let i = 1; i < 35; i++) {
			scroll.registerAnimatedElement(`${this.publicVars.cssId.anim?.siteMapListContentPageLinksItemWrapperCls}${i}`, 'site_map_list', { animCls: 'animate__zoomIn50P', once: true});
		}
	}

	bind() {
		this.msg('bind');
	}
}

export default List;